import { makeId } from '@/utils/makeId'

export type Filling = {
  id: string
  name: string
  description: string
  price: number
}

export const TRADITIONAL_PRICE = 9.99
export const FRUIT_PRICE = 14.99
export const SPECIAL_PRICE = 24.99

export const traditionalFillings: Filling[] = [
  {
    id: makeId(),
    name: 'Mousse de Chocolate',
    description: 'Mousse feito com chocolate nobre',
    price: TRADITIONAL_PRICE,
  },
  {
    id: makeId(),
    name: 'Prestígio',
    description: 'Recheio feito com coco flocado',
    price: TRADITIONAL_PRICE,
  },
  {
    id: makeId(),
    name: 'Doce de Leite',
    description: 'Mistura de leite condensado com doce de leite cremoso',
    price: TRADITIONAL_PRICE,
  },
]

export const fruitFillings: Filling[] = [
  {
    id: makeId(),
    name: 'Mousse de Morango',
    description: 'Mousse feito com morangos frescos',
    price: FRUIT_PRICE,
  },
  // {
  //   id: makeId(),
  //   name: 'Mousse de Abacaxi',
  //   description: 'Mousse feito com abacaxis frescos',
  //   price: FRUIT_PRICE,
  // },
  {
    id: makeId(),
    name: 'Mousse de Maracujá',
    description: 'Mousse feito com a polpa do maracujá',
    price: FRUIT_PRICE,
  },
]

export const specialFillings: Filling[] = [
  {
    id: makeId(),
    name: 'Nutella®',
    description: 'Mistura com Nutella® original',
    price: SPECIAL_PRICE,
  },
  {
    id: makeId(),
    name: 'Ninho®',
    description: 'Mistura de leite condensado com Ninho® original',
    price: SPECIAL_PRICE,
  },
  {
    id: makeId(),
    name: 'Ninho® com Morango',
    description: 'Mistura do nosso recheio de Ninho® com morangos frescos',
    price: SPECIAL_PRICE,
  },
  {
    id: makeId(),
    name: 'Nozes',
    description: 'Mistura de nozes frescas com chocolate nobre',
    price: SPECIAL_PRICE,
  },
  {
    id: makeId(),
    name: 'Sensação',
    description:
      'Mistura de mousse de morango reduzido com pingos de chocolate nobre',
    price: SPECIAL_PRICE,
  },
  // {
  //   id: makeId(),
  //   name: 'Mousse de Chocolate Branco',
  //   description: 'Mousse feito com chocolate branco nobre',
  //   price: SPECIAL_PRICE,
  // },
  {
    id: makeId(),
    name: 'Doce de Leite com Ameixa',
    description:
      'Mistura do nosso recheio de doce de leite com ameixas em calda',
    price: SPECIAL_PRICE,
  },
  {
    id: makeId(),
    name: 'Doce de Leite com Abacaxi',
    description:
      'Mistura do nosso recheio de doce de leite com abacaxis frescos',
    price: SPECIAL_PRICE,
  },
]

export const allFillings: Filling[] = [
  ...traditionalFillings,
  ...fruitFillings,
  ...specialFillings,
]
